import React, { useEffect } from "react";

const GoogleReviewsWidget2 = () => {
    useEffect(() => {
        const scriptId = "EmbedSocialWidgetScript";

        // Check if the script is already present
        if (!document.getElementById(scriptId)) {
            const script = document.createElement("script");
            script.id = scriptId;
            script.src = "https://embedsocial.com/cdn/aht.js";
            script.async = true;
            script.defer = true;
            document.head.appendChild(script);
        }

        return () => {
            const script = document.getElementById(scriptId);
            // Remove only if it exists and is inside the <head>
            if (script && script.parentNode === document.head) {
                document.head.removeChild(script);
            }
        };
    }, []);

    useEffect(() => {
        if (typeof window !== "undefined") {
            // Debounce function to optimize performance
            const debounce = (callback, delay) => {
                let timer;
                return () => {
                    clearTimeout(timer);
                    timer = setTimeout(callback, delay);
                };
            };

            // MutationObserver to detect changes in the widget
            const observer = new MutationObserver(
                debounce(() => {
                    const links = document.querySelectorAll("a");
                    links.forEach((link) => {
                        if (link.href.includes("&utm_campaign=free-widget")) {
                            link.style.setProperty("display", "none", "important");
                        }
                    });
                }, 100) // Debounce delay of 100ms
            );

            // Observe changes in the EmbedSocial widget
            const widgetContainer = document.querySelector(".embedsocial-widget");
            if (widgetContainer) {
                observer.observe(widgetContainer, { childList: true, subtree: true });
            }

            return () => observer.disconnect(); // Cleanup observer on unmount
        }
    }, []);

    return (
        <div>
            {/* EmbedSocial Widget Container */}
            <div className="embedsocial-widget" data-ref="75b7708a017032c89c64a3618b35d618">
                <a
                    href="https://embedsocial.com/google-reviews-widget/"
                    title="Add Google reviews on a website"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="powered-by-es es-slider"
                >
                    <img
                        src="https://embedsocial.com/cdn/icon/embedsocial-logo.webp"
                        alt="EmbedSocial"
                    />
                    <span> Google reviews widget </span>
                </a>
            </div>
        </div>
    );
};

export default GoogleReviewsWidget2;
